import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import IndexPage from '@/views/index.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'IndexPage',
    meta: {
      title: 'page_title.choose_plan',
    },
    component: IndexPage,
  },
  {
    path: '/payment-method/create/credit-card',
    name: 'PaymentMethodCreateCreditCardPage',
    meta: {
      title: 'page_title.payment_details',
    },
    component: () =>
      import(
        /* webpackChunkName: "sepa-direct-debit" */ '../views/payment-method/create/credit-card.vue'
      ),
  },
  {
    path: '/payment-method/create/sepa-direct-debit',
    name: 'PaymentMethodCreateSepaDirectDebitPage',
    meta: {
      title: 'page_title.payment_details',
    },
    component: () =>
      import(
        /* webpackChunkName: "sepa-direct-debit" */ '../views/payment-method/create/sepa-direct-debit.vue'
      ),
  },
  {
    path: '/payment-method/select/credit-card',
    name: 'PaymentMethodSelectCreditCardPage',
    meta: {
      title: 'page_title.payment_details',
    },
    component: () =>
      import(
        /* webpackChunkName: "sepa-direct-debit" */ '../views/payment-method/select/credit-card.vue'
      ),
  },
  {
    path: '/payment-method/select/sepa-direct-debit',
    name: 'PaymentMethodSelectSepaDirectDebitPage',
    meta: {
      title: 'page_title.payment_details',
    },
    component: () =>
      import(
        /* webpackChunkName: "sepa-direct-debit" */ '../views/payment-method/select/sepa-direct-debit.vue'
      ),
  },
  {
    path: '/confirm',
    name: 'ConfirmPage',
    meta: {
      title: 'page_title.confirm',
    },
    component: () =>
      import(/* webpackChunkName: "confirm" */ '../views/confirm.vue'),
  },
  {
    path: '/verify-credit-card-payment',
    name: 'VerifyCreditCardPaymentPage',
    meta: {
      title: 'page_title.verify_credit_card_payment',
    },
    component: () =>
      import(
        /* webpackChunkName: "verify-credit-card-payment" */ '../views/verify-credit-card-payment.vue'
      ),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
